import { FC, JSX } from 'react';

export interface ButtonProps {
    type?: 'button' | 'submit';
    disabled?: boolean;
    extendedClassName?: string;
    onClick?: () => void;
    btnText: string | JSX.Element;
    testId?: string;
    title?: string;
    variant?: 'primary' | 'success' | 'danger' | 'link' | 'danger_soft' | 'success_soft';
    icon?: React.ReactNode;
}

const Button: FC<ButtonProps> = ({
    type = 'button',
    disabled,
    extendedClassName,
    onClick,
    btnText,
    testId,
    title,
    variant = 'primary',
    icon,
}) => {
    const baseClass =
        variant === 'link'
            ? 'btn-link bg-transparent text-secondary hover:text-primary p-0 inline'
            : 'btn btn-sm shadow-none min-w-[170px] text-center font-coopGroteskBold text-[16px] border rounded-full h-[48px] p-[12px_20px] inline-block cursor-pointer transition-colors duration-150';

    let variantClass = '';
    switch (variant) {
        case 'link':
            variantClass = '';
            break;
        case 'danger':
            variantClass =
                'bg-custom-red-2 border-custom-red-2 hover:bg-custom-red-3 hover:border-custom-red-4 text-white';
            break;
        case 'danger_soft':
            variantClass = 'bg-custom-red-3 border-custom-red-2 text-[#303030]';
            break;
        case 'success':
            variantClass =
                'bg-custom-green-3 border-custom-green-3 hover:bg-custom-green-4 hover:border-custom-green-4 text-white';
            break;
        case 'success_soft':
            variantClass = 'bg-custom-green-4 border-custom-green-3 text-[#303030]';
            break;
        case 'primary':
        default:
            variantClass = 'bg-primary border-primary hover:bg-custom-blue-1 hover:border-custom-blue-2 text-white';
            break;
    }

    const iconClassName = 'inline-block';
    const disabledClass = disabled
        ? 'btn-disabled !bg-custom-grey-2 !border-custom-grey-2 !text-[#b2b2b2] !cursor-not-allowed'
        : '';

    const layoutClass = icon ? 'inline-flex items-center gap-[3px]' : '';

    const buttonClassName = [baseClass, layoutClass, variantClass, disabledClass, extendedClassName]
        .filter(Boolean)
        .join(' ');

    return (
        <button
            type={type}
            className={buttonClassName}
            data-test-id={testId}
            onClick={onClick}
            disabled={disabled}
            title={title}
        >
            {icon && <div className={iconClassName}>{icon}</div>}
            {btnText}
        </button>
    );
};

export default Button;
